import React, { useRef } from "react";
import Quill from "quill";
import Table from "quill-table-better";
import "quill-table-better/dist/quill-table-better.css";

const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    ['blockquote', 'code-block'],
    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
    [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
    [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
    [{ 'header': [1, 2, 3, false] }],
    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    [{ 'align': [] }],
    ['clean'],                                         // remove formatting button
    ['link', 'image'],
    ["table-better"],
];

const Editor = ({ defaultValue, onChange }: { defaultValue: string, onChange: (innerHTML: string) => void }) => {
    const editorRef = useRef<null | Quill>(null);

    Quill.register({
        "modules/table-better": Table,
    }, true);


    const mountInterval = setInterval(() => {
        try {
            if (editorRef.current != null) {
                return;
            }
            editorRef.current = new Quill("#editor", {
                theme: 'snow',
                modules: {
                    table: false,
                    toolbar: toolbarOptions,
                    'table-better': {
                        language: 'en_US',
                        menus: ['column', 'row', 'merge', 'table', 'cell', 'wrap', 'copy', 'delete'],
                        toolbarTable: true
                    },
                    keyboard: {
                        bindings: Table.keyboardBindings
                    },
                },

            });
            const dv = editorRef.current.clipboard.convert({ html: defaultValue });
            editorRef.current.updateContents(dv, "silent");
            editorRef.current.on(Quill.events.TEXT_CHANGE, _ => {
                onChange(editorRef.current!.root.innerHTML);
            });

            clearInterval(mountInterval);
        } catch (err) {
            console.error(err);
        }
    }, 250);


    return (
        <div id="editor" style={{ height: "50vh", marginBottom: "6rem" }}></div>
    );
};

export default Editor;
